export const ProjectLOADING = "project/Loading";
export const ProjectERROR = "project/Error";
export const ProjectListSUCCESS = "project/ListSuccess";
export const ProjectCreateSUCCESS = "project/CreateSuccess";
export const ProjectUpdateSUCCESS = "project/UpdateSuccess";
export const ProjectDeleteSUCCESS = "project/DeleteSuccess";
export const ProjectFavoriteListSUCCESS = "project/FavoriteListSuccess";
export const ProjectFavoriteAddSUCCESS = "project/FavoriteAddSuccess";
export const ProjectFavoriteRemoveSUCCESS = "project/FavoriteRemoveSuccess";
